import { IntlContext } from "context";
import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "routes";
import Footer from "components/Layout/Main/Footer";

const OurServicesConfirm: React.FC = () => {
    const intl = useContext(IntlContext);

    return (
        <React.Fragment>
            <div className="register">
                <div className="block-header">
                    <div className="container">
                        <h1 className="block-header__title">Réservation <span>confirmée</span></h1>
                    </div>
                </div>
                <div className="container">
                    <div className="register__container">
                        <h1 className="h2 text-center margin-bottom--3">
                            {intl.formatMessage("our_services.confirm.label.title")}
                        </h1>
                        <p className="register__subtitle">{intl.formatMessage("our_services.confirm.label.message")}</p>
                        <div className="flex flex--justify-content-center">
                            <NavLink className="btn btn--primary btn--square" to={ROUTES.MY_RESERVATIONS}>
                                {intl.formatMessage("our_services.confirm.label.back_bookings")}
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
};

export default OurServicesConfirm;
